import * as React from 'react';

interface ICookieAndPrivacy {
  onClickEvent: any;
  channelKey?: string;
}

class CookieAndPrivacy extends React.Component<ICookieAndPrivacy> {
  public render() {
    const { onClickEvent, channelKey } = this.props;
    const cookiesUrl = channelKey === 'lsb-b2c'
      ? 'https://www.pjhayman.com/cookie-policy/'
      : '/cookies';

    return (
      <div className="cookie-and-privacy-container">
        <div className="container">
          <div className="cookie-and-privacy-message">
            Please click here to view our {' '}
            <a href={cookiesUrl} target="_blank" rel="noopener noreferrer">
              Cookie Policy
            </a>.
            Cookies are used to ensure we provide the best customer experience.
            Continue use of this website assumes your acceptance of these policies.
          </div>
          <div className="cookie-and-privacy-btn" onClick={onClickEvent}>
            <div className="cookie-btn-content">
              {/*<MdCheck />*/}
              <span>
                OK
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CookieAndPrivacy;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/components/CookieAndPrivacy/index.tsx